import React from "react";
import { Checkbox } from "antd";
import { Icon } from "Components";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { useTranslation } from "react-i18next";

interface Props {
  disableSelection: boolean;
  organizationSelected: boolean;
  setOrganizationSelected: (value: boolean) => void;
  organizationUsers: number
}

const OrganizationRecipients: React.FC<Props> = ({
  disableSelection,
  organizationSelected,
  setOrganizationSelected,
  organizationUsers
}) => {
  const { t } = useTranslation();
  const disabled = (!organizationUsers || disableSelection);
  
  const handleOrgSelect = (event: CheckboxChangeEvent | null) => {
    if(event) event.stopPropagation();
    if(disabled) return;
    setOrganizationSelected(!organizationSelected);
  }

  return (
    <div className="phishing-step3__organization">
      <div className="phishing-step3__label">
        {t('phishingManager.campaignSetup.step3.organization.label')} <span className="required">*</span>
      </div>

      <div className="phishing-step3__org-box" onClick={() => handleOrgSelect(null)}>
        <Checkbox disabled={disabled} checked={organizationSelected} onChange={handleOrgSelect} />
        <div className="phishing-step3__org-info">
          <div className="phishing-step3__org-title">
            <Icon type="recipientBuilding" /> {t('phishingManager.campaignSetup.step3.organization.entireOrganization')}
          </div>
          <span className="phishing-step3__org-count">{t(`phishingManager.campaignSetup.step3.countUser${organizationUsers > 1 ? "s" : ""}`, {
            count: organizationUsers
          })}</span>
        </div>
      </div>
    </div>
  );
};

export default OrganizationRecipients;